import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { baseURL, headers } from '@/v2/constants/requests'

const QUERY_KEY = ['SettingsClinicWeekHours']
const EMPTY_OBJECT = {}

export const useSettingsClinicWeekHours = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/settings/clinic_week_hours`, {
        method: 'GET',
        headers,
      })
      if (!res.ok) {
        throw new Error("We couldn't load the clinic week hours")
      }
      return res.json()
    },
  })

  return { weekHours: data ?? EMPTY_OBJECT, isLoading, isError }
}

export const useUpdateClinicWeekHours = () => {
  const queryClient = useQueryClient()

  const { mutateAsync: updateWeekHours, ...rest } = useMutation({
    mutationFn: async weekHourData => {
      const res = await fetch(`${baseURL}/v2/rest/settings/clinic_week_hours`, {
        method: 'PATCH',
        headers,
        body: JSON.stringify({ clinic_week_hour: weekHourData }),
      })
      if (!res.ok) {
        const error = await res.json()
        throw new Error(error.errors || 'Could not update clinic week hours')
      }
      return res.json()
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY)
    },
  })

  return { updateWeekHours, ...rest }
}
